import { CreateGroups } from '@auteco/components/snopComponents'
import React from 'react'

const SnopCreateGroups = () => {
    return (
        <CreateGroups />
    )
}

export { SnopCreateGroups }